import React, { Dispatch, ReactElement, useState } from 'react';
import { TextEditor } from 'slovlex-idsk-react-components';
import {
  Button, Col, ErrorMessage, Input, Textarea,
} from 'idsk-react-components';
import FormElementWrapper from '../../../../FormElements/FormElementWrapper';
import {
  NavrhUzneseniaVladyBod,
} from '../../../../../model/sprievodnyDokument/navrhUzneseniaVlady/NavrhUzneseniaVladyBod';
import useFieldErrorMessages from '../../../../useFieldErrorMessages';
import './bodComponent.scss';

export interface BodProps {
  bodName: string,
  bodData: NavrhUzneseniaVladyBod,
  setBodData: Dispatch<NavrhUzneseniaVladyBod>,
  onDeleteBod: () => void;
}

const BodComponent = ({
  bodData, setBodData, bodName, onDeleteBod,
}: BodProps): ReactElement => {
  const { getFieldErrorMessage } = useFieldErrorMessages();
  const [bodInitData] = useState<NavrhUzneseniaVladyBod>(bodData);
  return (
    <Col>
      <div className="bod-heading-row-container">
        <span className="bod-name-label">{bodName}</span>
        <Button
          className="delete-bod-component-button"
          type="button"
          buttonStyle="negative"
          size="large"
          onClick={onDeleteBod}
        >Zmazať bod
        </Button>
      </div>
      <FormElementWrapper
        label="Zodpovedná osoba"
        fieldName={`zodpovednaOsobaBod${bodName}`}
        getFieldErrorMessage={getFieldErrorMessage}
      >
        <Textarea
          error={getFieldErrorMessage && getFieldErrorMessage(`zodpovednaOsobaBod${bodName}`)}
          id="zodpovednaOsoba"
          type="text"
          name="zodpovednaOsoba"
          value={bodData.zodpovednaOsoba}
          onChange={({ target }) => setBodData({ ...bodData, zodpovednaOsoba: target.value })}
          rows={4}
          maxLength={2048}
          showRemaining
          expandHeight
        />
      </FormElementWrapper>
      <FormElementWrapper
        label="Text"
        fieldName={`text${bodName}`}
        getFieldErrorMessage={getFieldErrorMessage}
      >
        {getFieldErrorMessage(`text${bodName}`)
          && <ErrorMessage message={getFieldErrorMessage(`text${bodName}`)} />}
        <TextEditor
          initialState={bodInitData.text ?? ''}
          onChange={(data: string) => setBodData({ ...bodData, text: data })}
          maxLength={2048}
          showRemaining
        />
      </FormElementWrapper>
      <FormElementWrapper
        label="Termín"
        fieldName="termin"
        getFieldErrorMessage={getFieldErrorMessage}
      >
        <Input
          type="text"
          width="one-third"
          value={bodData.termin ?? ''}
          onChange={(event) => setBodData({ ...bodData, termin: event.target.value })}
          maxLength={256}
        />
      </FormElementWrapper>
    </Col>
  );
};

export default BodComponent;
